import React from "react";
import { CollectionCard } from "./CommunityCard";
import { ViewMode } from "@/store/zustand/communityPanelStore";
import { CollectionType } from "@/utils/types";
import { TagListItem } from "./TagListItem";

interface UIKitsViewProps {
  viewMode: ViewMode;
  collections: CollectionType[];
  selectedCollections: string[];
  setSelectedCollections: (collections: string[]) => void;
  componentCounts: Record<string, number>;
  handleFilterChange: () => void;
  leftPanelFilter: string;
}

export const UIKitsView: React.FC<UIKitsViewProps> = React.memo(
  function UIKitsView({
    viewMode,
    collections,
    selectedCollections,
    setSelectedCollections,
    componentCounts,
    handleFilterChange,
    leftPanelFilter,
  }) {
    const handleSelect = (collectionId: string) => {
      setSelectedCollections([collectionId]);
      handleFilterChange();
    };

    const filteredCollections = React.useMemo(() => {
      if (!leftPanelFilter) {
        return collections;
      }
      const lowerCaseFilter = leftPanelFilter.toLowerCase();
      return collections.filter((collection) =>
        collection.name.toLowerCase().includes(lowerCaseFilter),
      );
    }, [collections, leftPanelFilter]);

    return (
      <div className="overflow-y-scroll h-full auto-rows-min w-full shrink-0 scrollbar-hide">
        {viewMode === ViewMode.Grid && (
          <div className="grid grid-cols-1 gap-2 p-4">
            {filteredCollections.map((collection) => (
              <CollectionCard
                key={collection.id}
                collection={collection}
                count={componentCounts[collection.id.toString()] || 0}
                onSelect={() => handleSelect(collection.id.toString())}
              />
            ))}
          </div>
        )}
        {viewMode === ViewMode.List && (
          <div className="p-2 px-2 flex flex-col w-full gap-1">
            {filteredCollections.map((collection) => (
              <TagListItem
                key={collection.id}
                item={{
                  displayName: collection.name,
                  id: collection.id.toString(),
                  url: null,
                }}
                count={componentCounts[collection.id.toString()] || 0}
                isSelected={selectedCollections.includes(
                  collection.id.toString(),
                )}
                onSelect={() => handleSelect(collection.id.toString())}
              />
            ))}
          </div>
        )}
      </div>
    );
  },
);

export default UIKitsView;
